module.exports = __webpack_public_path__ + "static/media/nissan-vest.da010795.svg";